import {decode} from "jsog";

export const toData = response => decode(response.data)

export function validateIpAddress(ip) {
    if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(ip)) {
        return (true)
    }
    return (false)
}

export function isIpInRange(ip, min, max) {
    return IPtoNum(min) <= IPtoNum(ip) && IPtoNum(max) >= IPtoNum(ip);
}

function IPtoNum(ip){
    return Number(
      ip.split(".")
        .map(d => ("000"+d).substr(-3) )
        .join("")
    );
}

export function getDutchFormattedDate(date){
    if(date != null && Array.isArray(date) && date.length === 3) {
        return date[2] + " " + getDutchMonth(date[1]) + " " + date[0]
    } else if(date != null && date.split("-").length === 3)
    { 
        const textSplit = date.split("-")
        return textSplit[2] + " " + getDutchMonth(Number(textSplit[1])) + " " + textSplit[0]
    }
    else {
        return "";
    }
}

function getDutchMonth(month) {
    switch(month) {
        case 1:
            return "jan.";
        case 2:
            return "febr.";
        case 3:
            return "mrt.";
        case 4: 
            return "apr";
        case 5:
            return "mei";
        case 6:
            return "juni";
        case 7:
            return "juli";
        case 8:
            return "aug.";
        case 9:
            return "sep.";
        case 10:
            return "okt.";
        case 11:
            return "nov.";
        case 12:
            return "dec.";
        default:
          return "";
      }

}
